import React, { useState } from "react";
import {
    Box, Button, IconButton, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Tabs, Tab, Menu, MenuItem, ListItemIcon, ListItemText, Chip, Divider, Typography,
    Select, SelectChangeEvent
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import TakeReturnAction from "../../Modals/takereturnaction";
import RejectReasonModal from "../../Modals/rejectReason";

/* =======================
   RETURNS DATA
======================= */

const returnData = [
    {
        returnId: "RET-2025-001",
        date: "12/10/2025",
        orderId: "ORD-201",
        reason: "Product not as described",
        amount: "AED 100.00",
        vendorStatus: "Approved",
        adminStatus: "Pending Pickup Approval",
        status: "pending",
    },
    {
        returnId: "RET-2025-002",
        date: "13/10/2025",
        orderId: "ORD-426",
        reason: "Damaged item",
        amount: "AED 250.00",
        vendorStatus: "Received & Approved",
        adminStatus: "Pending Final Refund",
        status: "pending",
    },
    {
        returnId: "RET-2025-003",
        date: "14/10/2025",
        orderId: "ORD-512",
        reason: "Defective product",
        amount: "AED 75.00",
        vendorStatus: "Pending Approval",
        adminStatus: "Waiting for Vendor",
        status: "pending",
    },
    {
        returnId: "RET-2025-004",
        date: "15/10/2025",
        orderId: "ORD-999",
        reason: "Changed mind",
        amount: "AED 120.00",
        vendorStatus: "Rejected",
        adminStatus: "Closed",
        status: "rejected",
    },
    {
        returnId: "RET-2025-005",
        date: "16/10/2025",
        orderId: "ORD-777",
        reason: "Size issue",
        amount: "AED 50.00",
        vendorStatus: "Received & Approved",
        adminStatus: "Refunded",
        status: "approved",
    },
];

const ReturnAndRefund = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [openRejectModal, setOpenRejectModal] = useState(false);

    // Tabs State
    const [valueTabs, setValueTabs] = useState(0);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };

    const handleCloseModal = () => setOpenModal(false);
    const handleRefundProceed = () => setOpenModal(false);

    const handleRejectClick = () => {
        setOpenRejectModal(true);
    };

    const getStatusContext = (adminStatus: string) => {
        switch (adminStatus) {
            case "Waiting for Vendor":
                return { next: "Vendor Approval", prev: "Request Raised", owner: "Vendor", color: "#f59e0b" };
            case "Pending Pickup Approval":
                return { next: "Approve Pickup", prev: "Vendor Approved", owner: "Admin", color: "#3b82f6" };
            case "Pending Final Refund":
                return { next: "Release Refund", prev: "Product Received", owner: "Admin", color: "#3b82f6" };
            case "Refunded":
                return { next: "Completed", prev: "Admin Approved", owner: "System", color: "#10b981" };
            case "Closed":
                return { next: "Closed", prev: "Rejected", owner: "System", color: "#ef4444" };
            default:
                return { next: adminStatus, prev: "-", owner: "-", color: "#64748b" };
        }
    };
    return (
        <>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                PaperProps={{
                    sx: {
                        borderRadius: "12px",
                        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                        minWidth: "220px",
                        padding: "8px 0"
                    }
                }}
            >
                <MenuItem onClick={handleMenuClose} sx={{ py: 1.5 }}>
                    <ListItemIcon><CheckCircleOutlineIcon fontSize="small" sx={{ color: "#10b981" }} /></ListItemIcon>
                    <ListItemText primary="Approve" primaryTypographyProps={{ fontSize: "14px", fontWeight: 500 }} />
                    <Chip label="AI ALERT" size="small" sx={{ ml: 1, backgroundColor: "#fee2e2", color: "#ef4444", fontSize: "10px", height: "18px", fontWeight: 700 }} />
                </MenuItem>
                <MenuItem onClick={handleMenuClose} sx={{ py: 1.5 }}>
                    <ListItemIcon><SyncAltOutlinedIcon fontSize="small" sx={{ color: "#3b82f6" }} /></ListItemIcon>
                    <ListItemText primary="Force Vendor Review" primaryTypographyProps={{ fontSize: "14px" }} />
                </MenuItem>
                <MenuItem onClick={handleMenuClose} sx={{ py: 1.5 }}>
                    <ListItemIcon><FlagOutlinedIcon fontSize="small" sx={{ color: "#9a3412" }} /></ListItemIcon>
                    <Box>
                        <ListItemText primary="Flag Customer" primaryTypographyProps={{ fontSize: "14px" }} />
                        <Typography variant="caption" sx={{ color: "#64748b", display: "block", mt: -0.5 }}>Sara Ahmed #632034</Typography>
                    </Box>
                </MenuItem>
                <Divider sx={{ my: 1 }} />
                <MenuItem onClick={() => { handleMenuClose(); navigate("view"); }} sx={{ py: 1.5 }}>
                    <ListItemIcon><VisibilityOutlinedIcon fontSize="small" /></ListItemIcon>
                    <ListItemText primary="View Return Details" primaryTypographyProps={{ fontSize: "14px" }} />
                    <ChevronRightIcon fontSize="small" sx={{ ml: "auto", color: "#94a3b8" }} />
                </MenuItem>
            </Menu>



            <div className="main_title">
                <h1>Returns & Refunds</h1>
                <p>    <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Returns & Refunds</p>
            </div>
            <div className="stats_boxes gap_m">

                {/* Total Orders */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            12
                            <p>Total Returns</p>
                        </h2>
                        <figure className="blue">
                            <Inventory2OutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                </a>

                {/* Total Revenue */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            3
                            <p>Pending Review</p>
                        </h2>
                        <figure className="sucess">
                            <AttachMoneyOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                </a>

                {/* Pending Orders */}


                {/* Delivered Orders */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            68
                            <p>Approved</p>
                        </h2>
                        <figure className="sucess">
                            <LocalShippingOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                </a>



                {/* Average Order Value */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            AED 2,080
                            <p>Total Refunded</p>
                        </h2>
                        <figure className="blue">
                            <TrendingUpOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                </a>

                {/* Refund Requests */}


            </div>

            {/* =======================
                SEARCH & FILTER
            ======================= */}
            <Box className="custom_tabs1 mt_20">
                <Tabs value={valueTabs} onChange={handleChangeTabs} aria-label="return status tabs" className="custom_tabs_links">
                    <Tab label="Total Returns" />
                    <Tab label="Pending" />
                    <Tab label="Approved" />
                    <Tab label="Rejected" />
                </Tabs>
            </Box>
            <div className="table_flex mt_20">
                <div className="lt">
                    <div className="cards">
                        <div className="table_header">
                            <Box className="search_box">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search by return number..."
                                />
                            </Box>

                            <div className="form">
                                <div className="control_group">
                                    <input type="date" />
                                </div>
                            </div>
                        </div>

                        {/* =======================
                    RETURNS TABLE
                ======================= */}
                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Return Id</TableCell>
                                        <TableCell>Order Id</TableCell>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Reason</TableCell>
                                        <TableCell>Amount</TableCell>
                                        <TableCell>Return Progress</TableCell>
                                        <TableCell>Action Required</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {returnData
                                        .filter((item) => {
                                            if (valueTabs === 1) return item.status === "pending";
                                            if (valueTabs === 2) return item.status === "approved";
                                            if (valueTabs === 3) return item.status === "rejected";
                                            return true;
                                        })
                                        .map((item, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell>
                                                    <b>{item.returnId}</b>
                                                </TableCell>
                                                <TableCell>
                                                    <b>{item.orderId}</b>
                                                </TableCell>

                                                <TableCell>{item.date}</TableCell>

                                                <TableCell>{item.reason}</TableCell>


                                                <TableCell>
                                                    <b>{item.amount}</b>
                                                </TableCell>

                                                <TableCell>
                                                    <Box>
                                                        <Typography variant="body2" sx={{ fontWeight: 700, color: getStatusContext(item.adminStatus).color }}>
                                                            NEXT: {getStatusContext(item.adminStatus).next}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ display: 'block', color: '#64748b', fontStyle: 'italic' }}>
                                                            Previously: {getStatusContext(item.adminStatus).prev}
                                                        </Typography>
                                                        <Chip
                                                            label={getStatusContext(item.adminStatus).owner}
                                                            size="small"
                                                            sx={{
                                                                mt: 0.5,
                                                                height: '18px',
                                                                fontSize: '10px',
                                                                backgroundColor: getStatusContext(item.adminStatus).color + '15',
                                                                color: getStatusContext(item.adminStatus).color,
                                                                border: `1px solid ${getStatusContext(item.adminStatus).color}30`
                                                            }}
                                                        />
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    {item.adminStatus === "Pending Pickup Approval" && (
                                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                                            <Button className="btn btn_primary sm" sx={{ minWidth: '130px' }}>
                                                                Approve Pickup
                                                            </Button>
                                                            <Button
                                                                variant="outlined"
                                                                color="error"
                                                                size="small"
                                                                onClick={handleRejectClick}
                                                                sx={{ textTransform: 'none', borderRadius: '4px' }}
                                                            >
                                                                Reject
                                                            </Button>
                                                        </Box>
                                                    )}
                                                    {item.adminStatus === "Pending Final Refund" && (
                                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                                            <Button className="btn btn_primary sm" sx={{ minWidth: '130px' }}>
                                                                Approve Refund
                                                            </Button>
                                                            <Button
                                                                variant="outlined"
                                                                color="error"
                                                                size="small"
                                                                onClick={handleRejectClick}
                                                                sx={{ textTransform: 'none', borderRadius: '4px' }}
                                                            >
                                                                Reject
                                                            </Button>
                                                        </Box>
                                                    )}
                                                    {item.adminStatus === "Waiting for Vendor" && (
                                                        <Typography variant="caption" color="textSecondary">Waiting for Vendor...</Typography>
                                                    )}
                                                    {item.adminStatus === "Refunded" && (
                                                        <Chip label="Success" size="small" color="success" variant="outlined" />
                                                    )}
                                                    {item.adminStatus === "Closed" && (
                                                        <Chip label="Closed" size="small" variant="outlined" />
                                                    )}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <IconButton onClick={handleMenuOpen}>
                                                        <MoreHorizIcon />
                                                    </IconButton>
                                                </TableCell>

                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_panel">
                        <h4>AI Summary</h4>

                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>

                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>

                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <TakeReturnAction
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
                onProceed={handleRefundProceed}
            />
            <RejectReasonModal
                open={openRejectModal}
                onClose={() => setOpenRejectModal(false)}
                setOpen={setOpenRejectModal}
            />
        </>
    );
};

export default ReturnAndRefund;
